import { useSession, signIn } from "next-auth/react"
import React, { useEffect } from "react";
import { useState } from "react";
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, ClientSideRowModelModule } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useQuery } from "@apollo/client";
import Navbar from "../../components/shared/AppBar";
import { Button } from "rsuite";
import AddTenantModal from "../../components/modals/AddTenantModal";
import EditDeleteModal from "../../components/modals/EditDeleteModal";
import BtnCellRenderer from "../../components/shared/BtnCellRenderer";
import styles from '../../styles/tenant.module.css'
import { LOAD_TENANTS } from "../../graphql/TenantQueries";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

function InventoryPage({ graphqlApi }: { graphqlApi: string }) {
    const [openModal, setOpenModal] = useState(false);
    const [openActionModal, setOpenActionModal] = useState(false);
    const [user, setUser] = useState("");
    const [selectedTenant, setSelectedTenant] = useState<any>(null);
    const { status, data: session } = useSession();
    const { loading, data } = useQuery(LOAD_TENANTS, {
        skip: !session?.accessToken,
        notifyOnNetworkStatusChange: false,
        fetchPolicy: 'cache-first'
    });

    const columnDefs = React.useMemo(() => [
        {
            field: 'name',
            headerName: 'Name',
            minWidth: 200,
            cellRenderer: (params: any) => {
                const isDisabled = params.data?.meta?.disabled === true;
                return (
                    <span>
                        {params.value}
                        {isDisabled && (
                            <span style={{
                                marginLeft: 8,
                                fontSize: 11,
                                padding: '2px 6px',
                                borderRadius: 4,
                                background: '#f5a623',
                                color: '#fff',
                                fontWeight: 600,
                                verticalAlign: 'middle',
                            }}>
                                Disabled
                            </span>
                        )}
                    </span>
                );
            },
        },
        { field: 'displayName', headerName: 'Display Name', minWidth: 250 },
        { field: 'id', headerName: 'ID', minWidth: 250 },
        {
            field: 'actions',
            headerName: 'Actions',
            cellRenderer: BtnCellRenderer,
            cellRendererParams: {
              clicked: function(field: string, rowData: any) {
                setOpenActionModal(true)
                setUser(field)
                setSelectedTenant(rowData)
              },
            },
            minWidth: 120,
            maxWidth: 120,
            resizable: false,
            sortable: false,
            filter: false
          },
    ], [])
    useEffect(() => {
        if (session?.error === "RefreshAccessTokenError") {
            signIn("keycloak"); // Force sign in to hopefully resolve error
        }

    }, [session]);

    const tenants = React.useMemo(() => {
        return data?.getTenants?.filter((el: { meta?: { deletedOn?: string | null } | null } | null) =>
            el && (
                el.meta?.deletedOn === '' ||
                el.meta?.deletedOn === undefined ||
                el.meta?.deletedOn === null
            )
        ) || [];
    }, [data]);

    if (status === 'loading' || loading) return <h3> Loading... </h3>

    if (status === "unauthenticated") {
        signIn("keycloak");
        return null;
    }
    else if (status === 'authenticated') {
        return (
            <>
                <Navbar />
                <div style={{ height: '700px' }}>
                    <div className="ag-theme-alpine" style={{ height: '75%', width: '900px', padding: '20px' }}>
                        <div style={{ paddingBottom: 10 }}>
                            <Button onClick={() => { setOpenModal(true) }} className={styles["button"]}>Add Tenant</Button>
                        </div>
                        {openModal && <AddTenantModal setOpenModal={setOpenModal} graphqlApi={graphqlApi} />}
                        {openActionModal && <EditDeleteModal fieldData={user} tenantMeta={selectedTenant?.meta} setOpenActionModal={setOpenActionModal} />}
                        <AgGridReact
                            rowData={tenants}
                            columnDefs={columnDefs}
                            className={styles["gridTable"]}
                            theme="legacy"
                            defaultColDef={{
                                resizable: true,
                                sortable: true,
                                filter: false,
                                flex: 1,
                                cellStyle: { display:'flex',justifyContent: 'left',alignItems: 'center', fontSize: '14px' },
                                headerClass: 'ag-header-large'
                            }}
                            suppressColumnVirtualisation={true}
                            animateRows={false}
                            headerHeight={50}
                            rowHeight={45}
                        />

                    </div>
                </div>
            </>

        )
    }

    return null;
}

export async function getServerSideProps() {
    // Use the correct environment variable that matches K8s deployment
    const graphqlApi = process.env.NEXT_PUBLIC_GRAPHQL_API || process.env.GRAPHQL_API
    return { props: { graphqlApi } }
}

export default InventoryPage;



